import { render, staticRenderFns } from "./AccreditationPrintPass_glamorganCricket.vue?vue&type=template&id=1120632c&scoped=true&"
import script from "./AccreditationPrintPass_glamorganCricket.vue?vue&type=script&lang=js&"
export * from "./AccreditationPrintPass_glamorganCricket.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationPrintPass_glamorganCricket.vue?vue&type=style&index=0&id=1120632c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120632c",
  null
  
)

export default component.exports